export const SOURCE_TYPE = [
  {
    key: "0",
    text: "แหล่งเงินกู้ในประเทศ",
    value: "L",
  },
  {
    key: "1",
    text: "แหล่งเงินกู้ต่างประเทศ",
    value: "F",
  },
];
export const CURRENCY_LIST = [
  { key: "USD", text: "USD", value: "USD" },
  { key: "JPY", text: "JPY", value: "JPY" },
];
export const CURRENCY_LIST_DELETE = [
  { key: "USD", text: "USD", value: "USD" },
  { key: "JPY", text: "JPY", value: "JPY" },
  {
    key: "Delete",
    text: "Delete",
    value: "Delete",
  },
];

export const CURRENCY_DELETE_OPTION = {
  key: "Delete",
  text: "Delete",
  value: "Delete",
};
